import {
  getCompanyId,
  getDepartmentName,
  getStoreId
} from 'components/StoreSelect/slice';
import { useFetchPrintAuthorizedVendors } from 'hooks/useClientDataServices';
import { useAppSelector } from 'store/hooks';
import type { PrintChecksDataResult, PrintChecksResponse } from './types';

export const usePrintChecksData = (
  onSuccess: (data: PrintChecksResponse) => void,
  refetchOnMount?: boolean,
  retry = 0,
  retryOnMount = false
): PrintChecksDataResult => {
  const companyId = useAppSelector(getCompanyId);
  const storeId = useAppSelector(getStoreId);
  const selectedDepartmentName = useAppSelector(getDepartmentName);
  const queryResult = useFetchPrintAuthorizedVendors(
    companyId,
    storeId,
    onSuccess,
    refetchOnMount,
    retry,
    retryOnMount,
    selectedDepartmentName
  );

  const rowData = queryResult?.data?.vendors || [];
  return {
    rowData,
    ...queryResult
  };
};
